module.exports = __webpack_public_path__ + "static/media/armenia-small.dae94912.jpg";